import {Button, Grid, TextField, Typography} from "@mui/material";
import {ISolicitacaoQuickFix} from "@models/solicitacoes/ISolicitacaoQuickFix.ts";
import React, {useState} from "react";
import dayjs from "dayjs";
import {ContaContabilPesquisa} from "@components/contaContabil/ContaContabilPesquisa.tsx";
import {SaveOutlined} from "@mui/icons-material";
import {_SolicitacoesEndpoints} from "@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {useAuth} from "@contexts/hooks/UseAuth.tsx";

export interface CreateQuickFixComponentProps {
    solicitacaoId: number;
    onSuccess?: (q: ISolicitacaoQuickFix) => void;
    onError?: (error: Error) => void;
}

export function CreateQuickFixComponent(props: CreateQuickFixComponentProps) {
    const {solicitacaoId} = props;
    const {Get} = useApi();
    const {createAlertFromResponse} = useAlert()
    const {userData} = useAuth()
    const [value, setValue] = useState<ISolicitacaoQuickFix>({
        id: 0,
        dataSolicitacao: dayjs(),
        status: 'Pendente',
        justificativa: "",
        solicitacaoId: solicitacaoId,
        solicitanteId: userData?.id ?? 0,
        toValue: "",
        quickFixType: 'ContaContabil',
    })

    return (
        <Grid container>
            <Grid size={12}>
                <Typography>Esta funcionalidade permite que você requisite uma correção rápida para o
                    solicitante.</Typography>
            </Grid>
            <Grid size={12} mt={2}>
                <TextField value={value.justificativa}
                           onChange={e => setValue({...value, justificativa: e.target.value})}
                           label={'Justificativa'}/>
            </Grid>
            <Grid size={12}>
                {value.quickFixType == 'ContaContabil' && <ContaContabilPesquisa onSelect={x => {
                    setValue({...value, toValue: (x?.id ?? '').toString()});
                }}/>
                }
            </Grid>
            <Grid size={12} mt={1.5}>
                <Grid container justifyContent={'end'}>
                    <Button endIcon={<SaveOutlined/>} variant={'outlined'}
                            onClick={() => {
                                Get(_SolicitacoesEndpoints.CreateQuickFixRequest(value)).then(x => {
                                    if (x.status == 'Success') {
                                        if (props.onSuccess != null)
                                            props.onSuccess(x.items);
                                    }
                                    createAlertFromResponse(x)
                                })
                            }}
                    >Enviar</Button>
                </Grid>
            </Grid>
        </Grid>
    );

}